export default "84bc9b8f13a7b60a.svg"